import ReactPlayer from 'react-player'
import 'react-responsive-carousel/lib/styles/carousel.min.css'
import { Carousel } from 'react-responsive-carousel'

const YoutubeSlide = ({ url }: { url: string; }) => (
  <ReactPlayer width="100%" height="35rem" url={url} playing={false} />
);

export default function VideoPlayer() {
  //@ts-ignore
  const customRenderItem = (item, props) => <item.type {...item.props} {...props} />;

  const getVideoThumb = (videoId: string) => `https://img.youtube.com/vi/${videoId}/default.jpg`;

  const getVideoId = (url: string) => url.substr('https://www.youtube.com/embed/'.length, url.length);
  //@ts-ignore
  const customRenderThumb = (children) =>
    //@ts-ignore
    children.map((item) => {
      let i = 0;
      const videoId = getVideoId(item.props.url);
      return <img key={i++} src={getVideoThumb(videoId)} />;
    });
  //inserir novos videos aqui
  return (
    <Carousel key="carousel" renderItem={customRenderItem} renderThumbs={customRenderThumb}>
      <YoutubeSlide key="youtube-1" url="https://www.youtube.com/embed/AVn-Yjr7kDc" />
      <YoutubeSlide key="youtube-2" url="https://www.youtube.com/embed/mOdmi9SVeWY" />
      <YoutubeSlide key="youtube-3" url="https://www.youtube.com/embed/n0F6hSpxaFc" />
      <YoutubeSlide key="youtube-4" url="https://www.youtube.com/embed/0uGETVnkujA" />
    </Carousel>
  );
}